<template>
  <!--
    v-select como tipo de FormulateInput (type="vselect", registrado en main.js).
    Al ser un input de vue-formulate sigue entrando en la validación del
    FormulateForm y en su v-model, cosa que un v-select suelto no hace.
    Recibe las mismas props que un type="select": options y placeholder.
  -->
  <div :class="context.classes.element" :data-type="context.type">
    <v-select
      class="selvue-custom"
      :class="{ 'selvue-custom-invalid': invalido }"
      :input-id="context.id"
      :options="context.options"
      :value="seleccionada"
      :placeholder="context.placeholder || ''"
      :disabled="deshabilitado"
      :clearable="false"
      :selectable="(opcion) => !opcion.disabled"
      :filter-by="filtrar"
      label="label"
      @input="elegir"
      @search:blur="context.blurHandler"
    >
      <template #no-options>Sin resultados.</template>
    </v-select>
  </div>
</template>

<script>
// Para que "area" encuentre "Área".
const normalizar = (texto) =>
  String(texto ?? "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase();

export default {
  name: "FormulateVSelect",
  props: {
    context: {
      type: Object,
      required: true,
    },
  },
  computed: {
    // El modelo guarda solo el value de la opción, como el select nativo.
    // vue-formulate pasa los value numéricos a string y el modelo puede traer
    // el id como número (modo edición): se comparan como string.
    seleccionada() {
      const valor = this.context.model;
      if (valor === undefined || valor === null || valor === "") return null;
      return (
        this.context.options.find((opcion) => String(opcion.value) === String(valor)) ||
        null
      );
    },
    deshabilitado() {
      const disabled = this.context.attributes?.disabled;
      return disabled !== undefined && disabled !== false;
    },
    // El mismo criterio con el que vue-formulate pinta los demás inputs
    // (hasErrors en wrapper-class): solo después del blur o del submit.
    invalido() {
      return (
        this.context.visibleValidationErrors.length > 0 ||
        this.context.errors.length > 0
      );
    },
  },
  methods: {
    elegir(opcion) {
      this.context.model = opcion ? opcion.value : "";
    },
    filtrar(opcion, label, busqueda) {
      return normalizar(label).includes(normalizar(busqueda));
    },
  },
};
</script>
